import type { WhatsNewBody } from '../types';

export default {
  title: 'Export an RFI onto the company RFI form',
  summary:
    'An RFI can now be exported to Excel onto the company’s RFI form, already filled in and ready to attach in Outlook.',
  details: [
    'Boxes that need a person stay yellow for you to fill in.',
    'Date stays blank until the RFI is marked sent. A long question or response continues on a second sheet.',
  ],
  audience: { label: 'project managers and engineers', test: (a) => a.editsProjects },
  tryIt: { to: '/projects', label: 'Open Projects' },
  guide: { topic: 'mod-rfis-export' },
} satisfies WhatsNewBody;
